import React from "react"
import * as Style from "./Button.module.scss"

const Button = props => {
  return (
    <button
      onClick={props.buttonHandler}
      onMouseDown={props.mouseDownHandler}
      type={props.type}
      className={`${Style.custom_button} ${props.style}`}
      data-type={props.dataset}
    >
      {props.children}
    </button>
  )
}

export default Button
